import { render, staticRenderFns } from "./tongdian.vue?vue&type=template&id=effd0a4c&scoped=true&"
import script from "./tongdian.vue?vue&type=script&lang=js&"
export * from "./tongdian.vue?vue&type=script&lang=js&"
import style0 from "./tongdian.vue?vue&type=style&index=0&id=effd0a4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effd0a4c",
  null
  
)

export default component.exports